/**
 * Thin wrapper around document.execCommand for the SignatureEditor's
 * Bold/Italic/Underline toolbar.
 *
 * execCommand is deprecated in the spec but still implemented in every
 * shipping browser (Chrome/Edge/Safari/Firefox) as of writing — there is no
 * broadly-supported non-deprecated replacement for "toggle bold within a
 * contentEditable selection" (the alternative, manual Selection/Range
 * manipulation + wrapping nodes by hand, is considerably more code for
 * equivalent behavior). Isolated here so if/when it's actually removed from
 * browsers, only this one file needs replacing.
 */

export function toggleBold() {
  document.execCommand('bold');
}

export function toggleItalic() {
  document.execCommand('italic');
}

export function toggleUnderline() {
  document.execCommand('underline');
}
